import { JobTypeEntity } from '../entities/job-type-entity';

export default class State {
  loaded = false;

  items: Array<JobTypeEntity> = [];
}
